import { render, staticRenderFns } from "./FormRatingBorderless.vue?vue&type=template&id=863ca526&"
import script from "./FormRatingBorderless.vue?vue&type=script&lang=js&"
export * from "./FormRatingBorderless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports